module.exports = __webpack_public_path__ + "static/media/chat-notify.a02819e1.svg";